<template>
  <div class="noAlMargen">
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <h4 v-if="activarTitulos" style="text-align:center">TU PATIENT JOURNEY</h4>

      <b-row style="width: 100%;">
          <b-row class="encabezado-state" style="background-color: rgb(209, 236, 241) !important">
            <b-col cols="2" v-for="datoEtapa in this.datos" v-bind:key="datoEtapa.idEtapa">
              <div class="stage"
                   :style="'margin-right: 5px; color:white; background-color:'+datoEtapa.color"
                   v-b-tooltip.hover :title="datoEtapa.etapa">
                <div style="width:80%;margin-left: 8px;">{{datoEtapa.etapa}}</div>
              </div>
              <div class="stage-b"></div>
              <div class="stage-f" :style="'border-left: 10px solid '+datoEtapa.color+';'"></div>
            </b-col>
          </b-row>
          <div style="position: absolute; right: 40px">
              <b-icon icon="arrow-up-circle" aria-hidden="true" v-if="mostrar" @click="mostrar = !mostrar"
                      v-b-tooltip.hover title="Ocultar detalle del patient journey"></b-icon>
              <b-icon icon="arrow-down-circle" aria-hidden="true" v-if="!mostrar"  @click="mostrar = !mostrar"
                      v-b-tooltip.hover title="Mostrar detalle del patient journey"></b-icon>
          </div>
          <b-row class="encabezado-state" v-if="mostrar">
            <b-col cols="2" v-for="datoEtapa in this.datos" v-bind:key="datoEtapa.idEtapa">
              <div v-for="datoSubEtapa in datoEtapa.lstSubEtapasFull" v-bind:key="datoSubEtapa.idEtapa">
                <div class="stage"
                     :style="'margin-right: 5px; color:white; background-color:'+datoSubEtapa.color"
                     v-b-tooltip.hover :title="datoSubEtapa.etapa">
                  {{datoSubEtapa.etapa}}
                  <div v-if="datoSubEtapa.descripcion !== undefined
                  && datoSubEtapa.descripcion !== null && datoSubEtapa.descripcion.trim() !== ''">
                    <b-icon v-b-tooltip.hover :title="datoSubEtapa.descripcion" icon="exclamation-circle-fill" variant="danger"></b-icon>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
      </b-row>


  </div>
</template>

<script>
  export default {
    name: "PatientJourney",
    data: () => ({
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      max: 100,
      datos: []
    }),
    props: {
      idPaciente: {
        default: (value) => parseInt(value)
      },
      desactivarTitulos: Boolean,
      height: String,
      mostrar: Boolean
    },
    computed: {
      activarTitulos() {
        return this.desactivarTitulos !== undefined  && this.desactivarTitulos !== null && !this.desactivarTitulos
      },
      obtenerAltura() {
        return this.height !== undefined && this.height !== null ? this.height : "45px";
      }
    },
    mounted() {
      this.obtenerPatientJourneyPaciente();
    },
    created() {
      this.debug = this.$localStorageService.getDebug();
    },
    methods: {
      obtenerPatientJourneyPaciente() {
        this.datos = [];
        const params = {
          idPaciente: this.idPaciente
        }
        this.$http.post(this.$api + "paciente/obtenerPatientJourney", params)
          .then((response) => {
            if (response.data.data) {
              this.datos = response.data.data;
            }
          })
          .catch(function (error) {
            console.error(error);
          });
      }
    }
  };
</script>
<style>
  .encabezado-state {
    width: 100%;
    border-radius: 10px;
    padding: 5px;
    align-content: center;
    vertical-align: middle;
  }
  .encabezado-state > .col-2 {
    padding-right: 1px;
    padding-left: 1px;
  }
  .stage {
    font-weight: bold;
    background-color: #e4e9ed;
    align-items: center;
    justify-content: center;
    color: #505050;
    font-size: 8px;
    margin-bottom: 3px;
    border-radius: 8px;
    padding: 5px;
    height: 100%;
    border-style: solid;
    border-width: 1px;
    width: 100%;
  }
  .stage-b {
    content: "";
    display: block;
    width: 0;
    height: 0;
    border-top: 13px solid transparent;
    border-bottom: 13px solid transparent;
    border-left: 13px solid rgb(209, 236, 241);
    position: absolute;
    top: 50%;
    margin-top: -13px;
    z-index: 2;

    left: 0px;
    position: absolute;
  }
  .stage-f {
    content: "";
    display: block;
    width: 0;
    height: 0;
    border-top: 13px solid transparent;
    border-bottom: 13px solid transparent;
    border-left: 13px solid #e4e9ed;
    position: absolute;
    top: 50%;
    margin-top: -13px;
    z-index: 2;

    right: 0px;
    position: absolute;
    background-color: rgb(209, 236, 241);
  }
</style>